/**
 * Content type utilities for card components
 * Created by neo on 21.01.26
 */

export type ContentType = string;

// Types that are actual videos (show play icon)
const VIDEO_TYPES = ['activityWorkout', 'yoga', 'video', 'webinar', 'onlineMeeting'];

// Types that are workouts (show dumbbell/workout icon)
const WORKOUT_TYPES = ['workoutTemplate'];

// Types that are articles/reading content
const ARTICLE_TYPES = ['article', 'link'];

// Types that are mindfulness content
const MINDFULNESS_TYPES = ['breathing', 'meditation'];

export const isVideoContent = (type: ContentType): boolean => {
  return VIDEO_TYPES.includes(type);
};

export const isWorkoutContent = (type: ContentType): boolean => {
  return WORKOUT_TYPES.includes(type);
};

export const getContentTypeLabel = (type: ContentType): string => {
  switch (type) {
    case 'activityWorkout':
      return 'Video';
    case 'workoutTemplate':
      return 'Workout';
    case 'yoga':
      return 'Yoga';
    case 'video':
      return 'Video';
    case 'webinar':
      return 'Webinar';
    case 'onlineMeeting':
      return 'Live';
    case 'article':
      return 'Article';
    case 'link':
      return 'Link';
    case 'breathing':
      return 'Breathing';
    case 'meditation':
      return 'Meditation';
    case 'recipe':
      return 'Recipe';
    default:
      return type.charAt(0).toUpperCase() + type.slice(1);
  }
};

export const getContentTypeIcon = (type: ContentType): string => {
  return '';
};

export const getContentTypeColor = (type: ContentType): string => {
  if (isVideoContent(type)) {
    return '#F2A540';
  }

  switch (type) {
    case 'workoutTemplate':
      return '#00dda2';
    case 'article':
      return '#007763';
    case 'breathing':
    case 'meditation':
      return '#007763';
    case 'recipe':
      return '#F2A540';
    default:
      return '#00dda2';
  }
};
